
import { mapGetters } from 'vuex'
import { uniqWith, differenceWith, isEqual } from 'lodash-es'
import { mapQueryParams } from '@twago/query'
import { EFilter } from '@/helpers/enums'
import { extractLocation } from '@/helpers/search'

export default {
  name: 'Location',

  data() {
    return {
      tempSelectedRadius: 0,
      selectedRadius: 0
    }
  },

  computed: {
    ...mapGetters({
      getLocations: 'filters/getLocations'
    }),

    ...mapQueryParams({
      propName: 'selectedList',
      queryParam: EFilter.LOCATION,
      serializer: (data, ctx) => ctx.serialize(data),
      deserializer: (data, ctx) => ctx.deserialize(data),
      multiple: true
    })
  },

  watch: {
    selectedList(arr) {
      const bool = Boolean(arr.length)
      this.filterFilled = bool
    },

    [`$route.query.${EFilter.LOCATION}`](data) {
      if (!data) {
        this.clearFilter()
      }
    }
  },

  mounted() {
    this.tempSelectedRadius = this.selectedRadius
  },

  methods: {
    serialize(data) {
      return data
        ?.map((e) => encodeURIComponent(`${e.country}:${e.value}:${this.selectedRadius}`))
        ?.join(',')
    },

    deserialize(data) {
      const locationArr = []
      const getUri = extractLocation(data ?? [])

      if (getUri.resultLocation.length) {
        locationArr.push(
          ...getUri.resultLocation.map((i) => {
            const item = i.split(':')
            this.selectedRadius = item[2]

            return this.getLocations.find(
              (e) => !e.isCountry && e.value === item[1] && e.country === item[0]
            )
          })
        )
      }

      return locationArr
    },

    selectCountry(i) {
      const cities = this.getLocations.filter((e) => i.country === e.country && !e.isCountry)
      const includeOnly = cities.filter((j) => this.selectedList.filter((e) => j.value !== e.value))

      this.selectedList = uniqWith([...this.selectedList, ...includeOnly], isEqual)
    },

    disableCountry(i) {
      const cities = this.getLocations.filter((e) => e.country === i.country && !e.isCountry)
      const selected = this.selectedList.filter((e) => e.country === i.country)
      const checkDiff = differenceWith(cities, selected, isEqual)

      return !checkDiff.length
    },

    disableCity(i) {
      const cities = this.getLocations.filter((e) => e.value === i.value && e.country === i.country)
      const exist = this.selectedList.filter((e) => e.value === i.value && e.country === i.country)
      const checkDiff = differenceWith(cities, exist, isEqual)

      return !checkDiff.length
    },

    removeLocation(item) {
      const includeOnly = this.selectedList.filter(
        (e) => !(e.country === item.country && e.value === item.value)
      )

      this.selectedList = [...includeOnly]
    },

    applyRadius() {
      this.selectedRadius = this.tempSelectedRadius
      this.selectedList = [...this.selectedList]
    },

    checkDistanceUnits(kms) {
      if (['US', 'GB', 'MM', 'LR'].includes(this.$store.state.auth.user?.residenceCountry)) {
        const miles = Math.round(kms * 0.621371)
        return `${parseInt(miles)}mi`
      } else {
        return `${parseInt(kms)}km`
      }
    },

    clearFilter() {
      this.tempSelectedRadius = 0
      this.selectedRadius = 0
      this.selectedList = []
    }
  }
}
